import type { FC } from "react";

import { Row, type RowProps } from "@hightouch/htui";

import { Link } from "src/router";

// Activates the whole row via a stretched ::after; anchor when href is set.
// Lift content needing its own hover above the ::after (position + zIndex).
type RowButtonProps = RowProps & {
  href?: string;
  overlayRadius: RowProps["borderRadius"];
};

export const RowButton: FC<RowButtonProps> = ({
  href,
  overlayRadius,
  ...props
}) => {
  const shared: RowProps = {
    textAlign: "left",
    _after: {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: overlayRadius,
    },
    _focusVisible: { outline: "none", _after: { boxShadow: "outline" } },
    ...props,
  };

  return href ? (
    <Row
      as={Link}
      href={href}
      textDecoration="none"
      _hover={{ textDecoration: "none" }}
      {...shared}
    />
  ) : (
    // type=button so it can't submit an ancestor form
    <Row as="button" type="button" {...shared} />
  );
};
